import { ChevronDown, ChevronLeft, ChevronRight } from "lucide-react";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FaTimes } from "react-icons/fa";

const PropertyDetailsMediaSection = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [fullScreenImage, setFullScreenImage] = useState(null);

  useEffect(() => {
    setSelectedImage(images.find((img) => img.isThumbnail) || images[0]);
  }, [images]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && fullScreenImage) {
        setFullScreenImage(null);
      }
    };

    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, [fullScreenImage]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-6 gap-4 sm:gap-6 mb-6 sm:mb-8">
      {/* Main Large Image */}
      <div className="lg:col-span-4">
        <div className="bg-white rounded-xl shadow-md h-60 sm:h-80 md:h-96 lg:h-[26rem] overflow-hidden relative">
          <img
            src={selectedImage?.url}
            alt="img"
            onClick={() => setFullScreenImage(selectedImage)}
            className="w-full h-full object-center  object-cover transition-all duration-300"
          />

          {/* CATEGORY OVERLAY ON LARGE IMAGE */}
          {selectedImage?.category && selectedImage?.category !== "other" && (
            <span
              className="absolute bottom-2 left-2 bg-[rgba(0,0,0,0.45)] text-white
              px-2 py-1 rounded text-xs sm:text-sm tracking-wide"
            >
              {selectedImage.category}
            </span>
          )}
        </div>
      </div>

      {/* Thumbnails */}
      <div className="lg:col-span-2 relative">
        {/* LEFT OVERLAY */}
        <div className="lg:hidden lg:invisible pointer-events-none absolute left-0 top-0 h-full w-6 bg-gradient-to-r from-[rgba(0,0,0,0.59)] to-transparent flex items-center justify-center z-10">
          <span className="text-white text-sm font-bold opacity-90 select-none">
            <ChevronLeft className="size-6" />
          </span>
        </div>

        {/* RIGHT OVERLAY */}
        <div className="lg:hidden lg:invisible pointer-events-none absolute right-0 top-0 h-full w-8 bg-gradient-to-l from-[rgba(0,0,0,0.35)] to-transparent flex items-center justify-center z-10">
          <span className="text-white text-sm font-bold opacity-70 select-none">
            <ChevronRight className="size-6" />
          </span>
        </div>

        <div className="flex lg:grid lg:grid-cols-2 gap-2 sm:gap-4 items-center justify-start lg:justify-center overflow-x-auto lg:overflow-y-auto max-h-[26rem] px-4 lg:px-0 pb-2 hide-scrollbar">
          {images.map((img) => (
            <div
              key={img._id}
              onClick={() => setSelectedImage(img)}
              className="relative size-20 sm:size-24 md:size-28 lg:w-full lg:h-40 bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow cursor-pointer flex-shrink-0"
            >
              <img
                src={img.url}
                alt={img.category}
                className="w-full h-full object-cover hover:scale-105 transition-transform"
              />

              {/* CATEGORY OVERLAY */}
              {img.category !== "other" && (
                <span className="absolute bottom-0 left-0 w-full bg-[rgba(0,0,0,0.45)] text-white text-[10px] sm:text-xs py-1 px-1 text-center tracking-wide">
                  {img.category}
                </span>
              )}
            </div>
          ))}
        </div>
        {/* Down OVERLAY */}
        <div className="hidden lg:flex pointer-events-none absolute bottom-0 overflow-hidden opacity-80 -translate-x-1/2 left-1/2 size-8 bg-white/50 items-center rounded-full justify-center z-10">
          <span className="text-black text-sm font-bold opacity-70 select-none">
            <ChevronDown className="size-6" />
          </span>
        </div>
      </div>
      {fullScreenImage &&
        createPortal(
          <div
            className="fixed inset-0 bg-black/90 z-[9999] flex items-center justify-center p-4"
            onClick={() => setFullScreenImage(null)}
          >
            <button
              onClick={() => setFullScreenImage(null)}
              className="absolute top-4 right-4 p-2 bg-white/20 hover:bg-white/30 rounded-full transition-colors z-10"
            >
              <FaTimes className="w-6 h-6 text-white" />
            </button>

            <img
              src={fullScreenImage.url}
              alt="Full screen preview"
              className="max-w-full max-h-full object-contain"
              onClick={(e) => e.stopPropagation()}
            />

            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/70 text-white px-4 py-2 rounded-lg text-sm">
              {fullScreenImage.category}
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};
export default PropertyDetailsMediaSection